module.exports = __webpack_public_path__ + "static/media/licencia_dorso@2x.d9addc4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/licencia_dorso@2x.jpg
// module id = 355
// module chunks = 0